import { render } from "./ImprintModal.vue?vue&type=template&id=1e90e7ec&scoped=true"
import script from "./ImprintModal.vue?vue&type=script&lang=js"
export * from "./ImprintModal.vue?vue&type=script&lang=js"

import "./ImprintModal.vue?vue&type=style&index=0&id=1e90e7ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e90e7ec"]])

export default __exports__